<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
        <div class="page-header-top-container">
            <div class="page-name">GL Export</div>
        </div>
        <!--page content-->
        <div class="admin-page-content">
            <form id="importTasksform" enctype="multipart/form-data">
            <div class="form-row">
                <div class="col-md-6 form-group">
                    <label> Select Excel File to Import GL Export Data:</label>
                    <div>
                        <input style="display: none;" type="file" name="excl_file" accept=".xlsx,.xls" id="glexportupload" ref="fileglexportdata" v-on:change="handleFilesUploadCall()"/>
                        <label class="btn btn-secondary mb-0" for="glexportupload"><i class="fa fa-upload mr-3" aria-hidden="true"></i>Upload File ...</label>
                        <button type="button" v-on:click="importData" class="btn btn-primary">Import</button>
                    </div>
                </div>
            </div>
            </form>
        </div>
        <br>
        <div>
            <template>
                <!-- <div class="custom-table-name">Record not found</div> -->
            </template>
        </div>
        <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
import Vue from "vue";
import Footer from "@/components/partials/Footer";
import {commonMixins} from '../../mixins/commonMixins';
import EventBus from ".././event-bus";
import {importGLEport} from '../../config'
import axios from 'axios'

Vue.component("app-footer", Footer);

var app = '';

export default {
    name: 'GLExport',
    mixins: [commonMixins],
    data() {
        return {
                glexport_data:[],
                glexport_data_temp:[],
                filesData: [],
        }
    },
    created: function () {
    },
    beforeMount: function () {
        app = this;
    },
    mounted: function () {
        app.checkLocalStorage();
        app.setActiveMenu('glexport');
        EventBus.$emit("menu-selection-changed", "glexport");
    },
    methods: {
        checkLocalStorage : function () {       
            if(localStorage.getItem('user_obj')) {
                
                var userObj = localStorage.getItem('user_obj');
                if (userObj != null && userObj !== "") {
                    
                  //  self.$router.push('/dashboard');
                    // self.showHeader = true;
                    // alert("Hello");
                } else {
                    // self.$router.push('/');
                    window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                }
            } else {
                // self.$router.push('/');
                window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
            }
        },
        isNumeric: function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        importData() {
                if(app.filesData) {
                    if(app.filesData.length>0) {
                        $(".loading-container").show();
                    var formData = new FormData();
                    let file = app.filesData[0];
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Content-Type": "multipart/form-data",
                                },
                    };
                    formData.append('glexport', file, file.name);
                    // formData.append('access_token', window.localStorage.getItem('api_token'));
                    axios.post(importGLEport, formData, config)
                            .then(function (response) {
                            app.$refs.fileglexportdata.value = '';
                            if(response.data.code=='204') {
                                setTimeout(function() { $(".loading-container").hide(); },1000);
                                alert(response.data.content);
                            } else if (response.data.code == '200') {
                                alert(response.data.content);
                            } else {
                                console.log("fail");
                                app.glexport_data=[];
                            }
                            setTimeout(function() { $(".loading-container").hide(); },2000);
                            // $(".loading-container").hide();
                    })
                    .catch(function (err) {
                        app.$refs.fileglexportdata.value = '';
                        app.glexport_data=[];
                        // $(".loading-container").hide();
                        setTimeout(function() { $(".loading-container").hide(); },2000);
                    });
                    } else {
                        alert("Please select file to import.");
                    }
                } else {
                        alert("Please select file to import.");
                    }
                //$(".loading-container").hide();
        },
        handleFilesUploadCall: function () {
            if(app.$refs.fileglexportdata.files.length>0)
            {
                app.filesData = app.$refs.fileglexportdata.files;
                let allowedextentions = /(\.xls|\.xlsx)$/i;
                if (!allowedextentions.exec(app.filesData[0].name)) {
                    alert("Please select valid file!");
                    //app.filesData="";
                    app.$refs.fileglexportdata.value = '';
                }
            }
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/GLExport/glexport.vue